module.exports = __webpack_public_path__ + "img/pi-2-4-4.3ce01284.jpg";